// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-module--wrapper--Af3go"};